import {GET_CITY_ALIAS} from './actionTypes'

const initialState = {
  cityAliasOrGroup: '',
  // isLoading: false,
  // hasError: false,
  fulfilledAlias: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CITY_ALIAS:
      return {
        ...state,
        cityAliasOrGroup: action.payload,
        fulfilledAlias: true,
      }

    default:
      return state
  }
};

